import { noop } from "lodash";
import { ChangeEventHandler, FunctionComponent } from "react";
import { FieldError } from "react-hook-form";
import styled from "styled-components";
import { TextField } from "../../../../../components/forms/text";
import { languageTitles } from "../../../../../i18n";
import { colours } from "../../../../../styles/colours";
import { useNewLaunchContext } from "../../context";

interface IMultiTextFieldProps {
  value?: Record<string, string> | null;
  onChange: (x: Record<string, string>) => void;
  error?: Record<string, FieldError>;
}

const LanguageSpan = styled.div`
  color: ${colours.darkGrey};
`;

const SingleTextField: FunctionComponent<{
  value: string;
  onChange: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  language: string;
  disabled?: boolean;
  error?: FieldError;
}> = ({ language, error, ...props }) => {
  return (
    <>
      <LanguageSpan>
        {languageTitles[language as keyof typeof languageTitles]}
      </LanguageSpan>
      <TextField
        fullWidth
        {...props}
        helperText={error?.message}
        error={!!error}
      />
    </>
  );
};

const MultiTextField: FunctionComponent<IMultiTextFieldProps> = (props) => {
  const { languages: selectedLanguages } = useNewLaunchContext();
  return (
    <div>
      {selectedLanguages.length > 0 ? (
        selectedLanguages.map((lang) => (
          <SingleTextField
            key={lang}
            onChange={(x) =>
              props.onChange({ ...props.value, [lang]: x.target.value })
            }
            value={props.value?.[lang] ?? ""}
            language={lang}
            error={props.error?.[lang]}
          />
        ))
      ) : (
        <SingleTextField
          onChange={noop}
          value="Select at least 1 language"
          language="Choose Language"
          disabled
        />
      )}
    </div>
  );
};

export default MultiTextField;
